import { axiosAPI, responseHandler } from 'utils';

export default {
  getList(params) {
    return axiosAPI
      .get(`api/products`, { params })
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response.data;
      });
  },

  getProductSolutionsList(id) {
    return axiosAPI
      .get(`api/products/${id}/solutions-list`)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response.data;
      });
  },

  getProductName: async (productId) => {
    return responseHandler(
      axiosAPI.get(`/api/products/get-product-name/${productId}`)
    );
  },

  getUserAvailableProducts() {
    return axiosAPI
      .get('api/products/get-user-available')
      .then((res) => res.data)
      .catch((err) => err.response.data);
  },
  
  getProductsNames() {
    return axiosAPI
      .get('api/products/names')
      .then((res) => res.data)
      .catch((err) => err.response.data);
  },

  getMultiProductSolutions: async (productIds) => {
    return responseHandler(
      axiosAPI.post(`/api/products/get-multi-product-solutions`, { productIds })
    );
  },
};
